//利用規約の表示
import { useContext, useEffect } from "react";
import { FormControlLabel, Radio, RadioGroup, Grid } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler, Controller, Control, UseFormWatch } from "react-hook-form";
import { TitleParamContext } from '../../context/TitleContext';
import { TitleDiv, ContentsBox } from "../../customelements/CustomInput";
import { RegisterPageInfo, RegisterPageContext, RegisterPageTypeEnum, RegisterPageType } from "../../context/RegisterPageTypeContext";
import contact from "../../css/contact.module.css";
import faq from "../../css/faq.module.css";
import base from "../../css/base.module.css";
import market from "../../css/market.module.scss";
import { JumpPage } from "../../common/Util";

type FormParams = {
    lisenseRadio: number,
    parsonalInfoRadio: number,
    pccaseRadio: number,
}

export const ConsentForm = () => {

    const ctx = useContext(TitleParamContext);
    const registerPageTypeContext = useContext(RegisterPageContext);
    const location = useLocation();
    const navigate = useNavigate();
    const productParam: RegisterPageInfo = location.state as RegisterPageInfo

    const { handleSubmit, formState: { isValid }, control, watch } = useForm<FormParams>({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const onSubmit: SubmitHandler<FormParams> = (data: FormParams) => {
        if (registerPageTypeContext.registerPageInfo.registerPageType === RegisterPageTypeEnum.TrialLicense) {
            JumpPage("trial", {}, "", navigate);
        } else {
            JumpPage("RegisterUser", {}, "", navigate);
        }
    };

    const validationRules = {
        gender: {
            validate: (value: number) => value === 1 || '選択してください。'
        },
        gender2: {
            validate: (value: number) => {
                return value === 1 || '選択してください。'
            }
        }
    }

    //登録ページのパラメータを更新

    useEffect(() => {
        if (productParam.registerPageType === RegisterPageTypeEnum.TrialLicense) {
            ctx.setParamData({ mainTitle: "お試しライセンスの発行", firstSubTitle: "同意書", secondSubTitle: "" });
        } else {
            ctx.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "同意書", secondSubTitle: "" });
        }        
        registerPageTypeContext.setRegisterPageInfo({ registerPageType: productParam.registerPageType });
    }, []);
    //
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>                
                {
                    (() => {
                        switch (registerPageTypeContext.registerPageInfo.registerPageType) {
                            case RegisterPageTypeEnum.License:
                                return <LicenseConsentForm pageType={registerPageTypeContext.registerPageInfo.registerPageType} control={control} validate={validationRules.gender.validate} watch={watch} />
                            case RegisterPageTypeEnum.Pccase:
                                return <PcCaseConsentForm pageType={registerPageTypeContext.registerPageInfo.registerPageType} control={control} validate={validationRules.gender.validate} watch={watch} />
                            case RegisterPageTypeEnum.TrialLicense:
                                return <LicenseConsentForm pageType={registerPageTypeContext.registerPageInfo.registerPageType} control={control} validate={validationRules.gender.validate} watch={watch} />
                            default:
                                return <LicenseConsentForm pageType={registerPageTypeContext.registerPageInfo.registerPageType} control={control} validate={validationRules.gender.validate} watch={watch} />
                        }
                    })()
                }
                <Grid container spacing={3} alignItems="center" justifyContent="center" direction="column" style={{ marginBottom: "50px" }}>
                    <Grid item xs={1}>
                        <button className={market.marketButton} type="submit" disabled={!isValid}
                            onClick={(e) => {                                
                                //JumpPage("/ConsentForm/RegisterUser", {}, "", navigate);
                            }}>
                            次へ
                        </button>
                    </Grid>
                </Grid>
            </form>
        </>
    );
}

/**
 * ページの表示をライセンスとPcケースで分けて表示するためのパラメータ
 * */
type PageTypeParam = {
    pageType: RegisterPageType,
    control: Control<FormParams>,
    watch: UseFormWatch<FormParams>
    validate: (value: number) => boolean | string;
}

/**
 * ライセンスの利用規約
 * 
 * @param props
 */
export const LicenseConsentForm = (props: PageTypeParam) => {
    return (
        <>
            <section className={faq.faqArea}>
                <div className={faq.faqAreaInner}>
                    <div className={faq.faqCategory}>
                        <h3>ClickerAceライセンスについて</h3>
                        <div className={base.contentsDiv}>
                            1)ライセンスIDの発行とClickerAce利用端末への登録について<br />
                            ライセンス購入完了後、弊社より登録されたメールアドレス宛に、購入数量分のライセンスIDを送付致します。<br />
                            サポート契約を受けるClickerAce利用端末に対して、個々に異なるライセンスIDを登録してください。<br />
                            ライセンスIDを登録した端末がサポート対象となります。<br />
                            ただし、同一ライセンスIDを重複登録した場合はサポート対象外です。<br />
                            <br />
                            2)ライセンスの有効期間について<br />
                            ライセンスの有効期間は、購入日より1年間となります。<br />
                            ライセンス期間が過ぎた場合、サポート対象外となります。<br />
                            <br />
                            3)サポート対象外のClickerAce利用端末について<br />
                            サポート対象外のClickerAce利用端末では、以下の行為が禁止されています。<br />
                            ・有償プラグインの利用<br />
                            ・作成したプランファイル（シナリオ）及びプラグインファイル（カスタマイズプログラム）の作成端末以外での商用目的利用<br />
                            <br />
                            4)「有償サポートの拡張機能を試す」（お試しライセンスでの利用の）場合の利用条件について<br />
                            「有償サポートの拡張機能を試す」（お試しライセンスでの利用の）場合、ClickerAceの機能確認及び評価の目的に限ります。<br />
                            機能確認及び評価以外の目的での利用は、商用・非商用を問わず禁止されています。
                        </div>
                        <Controller
                            name="lisenseRadio"
                            control={props.control}
                            rules={{ validate: props.validate }}
                            render={({ field }) => (
                                <>
                                    <div className={contact.contactChack} style={{ display: "flex", justifyContent: "center" }}>
                                        <RadioGroup
                                            name={field.name}
                                            onChange={(e) => {
                                                const value = parseInt(e.target.value)
                                                if (!isNaN(value)) {
                                                    field.onChange(value)
                                                }
                                            }}
                                            value={field.value === undefined ? '' : field.value}
                                            row={true}
                                        >
                                            <FormControlLabel
                                                value={1}
                                                control={<Radio />}
                                                label="同意する"
                                                className={contact.radiolabel}
                                            />
                                            <FormControlLabel
                                                value={0}
                                                control={<Radio />}
                                                label="同意しない"
                                                className={contact.radiolabel}
                                            />
                                        </RadioGroup>
                                    </div>
                                </>
                            )}
                        />
                    </div>
                </div>
            </section>

            <section className={faq.faqArea}>
                <div className={faq.faqAreaInner}>
                    <div className={faq.faqCategory}>
                        <h3>個人情報の取り扱いについて</h3>
                        <div className={base.contentsDiv}>
                            1)個人情報の管理について<br />
                            ご提供いただきます個人情報の管理については、下記の者が責任を負います。<br />
                            <br />
                            【個人情報保護管理者】　株式会社オンサイト　総務部　個人情報保護担当<br />
                            【連絡先】　　　　　　　　　　東京都文京区本郷1-10-13 GSハイム本郷101<br />
                            <br />
                            <br />
                            2)利用目的について<br />
                            弊社製品に関する、各種サポートサービスの提供に利用いたします。<br />
                            <br />
                            3)第三者提供について<br />
                            上記の場合または法律で定められている場合を除いて、貴殿の個人情報を貴殿の同意を得ず第三者に開示･提供・預託することはありません。ただし、官公庁等から法的な手続きにより個人情報について開示が求められた場合は、関係法令に反しない範囲において、貴殿の同意なく貴殿の個人情報の内容を開示することがあります。<br />
                            （共同利用に関して）<br />
                            貴殿から当社が取得した個人情報を共同利用することはありません。<br />
                            4)委託について<br />
                            該当事項なし。<br />
                            5)個人情報の利用目的の通知・開示･訂正･追加又は削除・利用又は提供の拒否権について<br />
                            貴殿には、貴殿の開示対象個人情報の利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者での提供の停止を要求する権利があります。必要な場合には、上記「1) 個人情報の管理について」に示す、「個人情報保護管理者」までご連絡ください。<br />
                            また、措置を講じた後は、遅滞なくその旨を貴殿に通知いたします。<br />
                            6)提供の任意性について<br />
                            貴殿が当社に対して個人情報を提供することは任意です。ただし、個人情報を提供されない場合には、弊社製品に関する、各種サポートサービスができません。<br />
                            7)廃棄について<br />
                            貴殿から要請があった場合及び、サポートなど業務が終了した場合には、貴殿からお預かりした個人情報は適切な方法により廃棄します。<br />
                        </div>
                        <div className={contact.contactChack} style={{ display: "flex", justifyContent: "center" }}>
                            <Controller
                                name="parsonalInfoRadio"
                                control={props.control}
                                rules={{ validate: props.validate }}
                                render={({ field }) => (
                                    <>
                                        <RadioGroup
                                            name={field.name}
                                            onChange={(e) => {
                                                const value = parseInt(e.target.value)
                                                if (!isNaN(value)) {
                                                    field.onChange(value)
                                                }
                                            }}
                                            value={field.value === undefined ? '' : field.value}
                                            row={true}
                                        >
                                            <FormControlLabel
                                                value={1}
                                                control={<Radio />}
                                                label="同意する"
                                                className={contact.radiolabel}
                                            />
                                            <FormControlLabel
                                                value={0}
                                                control={<Radio />}
                                                label="同意しない"
                                                className={contact.radiolabel}
                                            />
                                        </RadioGroup>
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

/**
 * ライセンスの利用規約
 * 
 * @param props
 */
export const PcCaseConsentForm = (props: PageTypeParam) => {
    return (
        <>
            <TitleDiv title="RPA端末ケースについて" contents=""></TitleDiv>

            <Grid container spacing={3} alignItems="center" justifyContent="center" direction="column">
                <Grid item xs={1}>
                    <ContentsBox>
                        1)製品仕様について
                        本製品は、SurfacePro 6/7/8専用です。別PCで利用する場合、ケースに収まらない場合があります。

                        2)返品・交換について
                        お届けした商品に万一、破損・不具合等がございましたらサポートサイトより１週間以内に弊社までご連絡願います。
                        不具合確認後、お客様へ正常品を送らせていただきます。
                        交換商品が品切れの場合のみ、返金対応になりますのでご了承下さい。
                        原則としてお客様都合による返品は受けておりません。内容をご確認の上ご購入下さい。

                        3)補償内容について
                        RPA端末（PC）等の機材故障に関しては、いかなる理由であっても補償いたしません。

                    </ContentsBox>
                </Grid>
                <Controller
                    name="pccaseRadio"
                    control={props.control}
                    rules={{ validate: props.validate }}
                    render={({ field }) => (
                        <>
                            <Grid item xs={1}>
                                <RadioGroup
                                    name={field.name}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value)
                                        if (!isNaN(value)) {
                                            field.onChange(value)
                                        }
                                    }}
                                    value={field.value === undefined ? '' : field.value}
                                >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio />}
                                        label="同意する"
                                    />
                                    <FormControlLabel
                                        value={0}
                                        control={<Radio />}
                                        label="同意しない"
                                    />
                                </RadioGroup>
                            </Grid>
                        </>
                    )}
                />
            </Grid>

            <TitleDiv title="ClickerAceライセンス（付属）について" contents=""></TitleDiv>
            <Grid container spacing={3} alignItems="center" justifyContent="center" direction="column">
                <Grid item xs={1}>
                    <ContentsBox>
                        1)ライセンスIDの発行とClickerAce利用端末への登録について
                        ライセンス購入完了後、弊社より登録されたメールアドレス宛に、購入数量分のライセンスIDを送付致します。
                        サポート契約を受けるClickerAce利用端末に対して、個々に異なるライセンスIDを登録してください。
                        ライセンスIDを登録した端末がサポート対象となります。
                        ただし、同一ライセンスIDを重複登録した場合はサポート対象外です。

                        2)ライセンスの有効期間について
                        ライセンスの有効期間は、購入日より3ヶ月間となります。
                        ライセンス期間が過ぎた場合、サポート対象外となります。

                        3)サポート対象外のClickerAce利用端末について
                        サポート対象外のClickerAce利用端末では、以下の行為が禁止されています。
                        ・有償プラグインの利用
                        ・作成したプランファイル（シナリオ）及びプラグインファイル（カスタマイズプログラム）の作成端末以外での商用目的利用
                    </ContentsBox>
                </Grid>
                <Controller
                    name="lisenseRadio"
                    control={props.control}
                    rules={{ validate: props.validate }}
                    render={({ field }) => (
                        <>
                            <Grid item xs={1}>
                                <RadioGroup
                                    name={field.name}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value)
                                        if (!isNaN(value)) {
                                            field.onChange(value)
                                        }
                                    }}
                                    value={field.value === undefined ? '' : field.value}
                                >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio />}
                                        label="同意する"
                                    />
                                    <FormControlLabel
                                        value={0}
                                        control={<Radio />}
                                        label="同意しない"
                                    />
                                </RadioGroup>
                            </Grid>
                        </>
                    )}
                />
            </Grid>


            <TitleDiv title="個人情報の取り扱いについて" contents=""></TitleDiv>
            <Grid container spacing={3} alignItems="center" justifyContent="center" direction="column">
                <Grid item xs={1}>
                    <ContentsBox>
                        1)個人情報の管理について<br />
                        ご提供いただきます個人情報の管理については、下記の者が責任を負います。<br />
                        <br />
                        【個人情報保護管理者】　株式会社オンサイト　総務部　個人情報保護担当<br />
                        【連絡先】　　　　　　　　　　東京都文京区本郷1-10-13 GSハイム本郷101<br />
                        <br />
                        <br />
                        2)利用目的について<br />
                        弊社製品に関する、各種サポートサービスの提供に利用いたします。<br />
                        <br />
                        3)第三者提供について<br />
                        上記の場合または法律で定められている場合を除いて、貴殿の個人情報を貴殿の同意を得ず第三者に開示･提供・預託することはありません。ただし、官公庁等から法的な手続きにより個人情報について開示が求められた場合は、関係法令に反しない範囲において、貴殿の同意なく貴殿の個人情報の内容を開示することがあります。<br />
                        （共同利用に関して）<br />
                        貴殿から当社が取得した個人情報を共同利用することはありません。<br />
                        4)委託について<br />
                        該当事項なし。<br />
                        5)個人情報の利用目的の通知・開示･訂正･追加又は削除・利用又は提供の拒否権について<br />
                        貴殿には、貴殿の開示対象個人情報の利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者での提供の停止を要求する権利があります。必要な場合には、上記「1) 個人情報の管理について」に示す、「個人情報保護管理者」までご連絡ください。<br />
                        また、措置を講じた後は、遅滞なくその旨を貴殿に通知いたします。<br />
                        6)提供の任意性について<br />
                        貴殿が当社に対して個人情報を提供することは任意です。ただし、個人情報を提供されない場合には、弊社製品に関する、各種サポートサービスができません。<br />
                        7)廃棄について<br />
                        貴殿から要請があった場合及び、サポートなど業務が終了した場合には、貴殿からお預かりした個人情報は適切な方法により廃棄します。<br />
                    </ContentsBox>
                </Grid>
                <Controller
                    name="parsonalInfoRadio"
                    control={props.control}
                    rules={{ validate: props.validate }}
                    render={({ field }) => (
                        <>
                            <Grid item xs={1}>
                                <RadioGroup
                                    name={field.name}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value)
                                        if (!isNaN(value)) {
                                            field.onChange(value)
                                        }
                                    }}
                                    value={field.value === undefined ? '' : field.value}
                                >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio />}
                                        label="同意する"
                                    />
                                    <FormControlLabel
                                        value={0}
                                        control={<Radio />}
                                        label="同意しない"
                                    />
                                </RadioGroup>
                            </Grid>
                        </>
                    )}
                />
            </Grid>
        </>
    );
}